import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down.svg';
import ParkingRow from '../ParkingRow/ParkingRow';
import { ParkingsContext } from '../../contexts/ParkingsContext';

import styles from './style.cssmodule.css';

function ParkingsTable() {
  const {
    parkings, parkingsLoading, filters, dispatchFilters,
  } = useContext(ParkingsContext);
  const { formatMessage: t } = useIntl();

  if (!parkings && !parkingsLoading) return null;

  const initialLoading = !parkings && parkingsLoading;
  const InitialLoadingBar = parkingsLoading && (
  <div
    className={styles.loadingTable}
  />
  );

  const fields = [
    { name: 'username', label: t({ id: 'table.header.parking.username' }), additionalStyle: {} },
    { name: 'email', label: t({ id: 'table.header.parking.email' }), additionalStyle: {} },
    { name: 'phoneNumber', label: t({ id: 'table.header.parking.phoneNumber' }), additionalStyle: {} },
    { name: 'parkingType', label: t({ id: 'table.header.parking.parkingType' }), additionalStyle: {} },
    { name: 'carpark', label: t({ id: 'table.header.parking.carpark' }), additionalStyle: {} },
    { name: 'beginFrom', label: t({ id: 'table.header.parking.begin' }), additionalStyle: {} },
    { name: 'licensePlate', label: t({ id: 'table.header.parking.licensePlate' }), additionalStyle: {} },
    { name: 'reference', label: t({ id: 'table.header.parking.reference' }), additionalStyle: {} },
    { name: 'status', label: t({ id: 'table.header.parking.status' }), additionalStyle: {} },
    { name: 'payment', label: t({ id: 'table.header.parking.payment' }), additionalStyle: { textAlign: 'center' } },
    { name: 'actions', label: t({ id: 'table.header.parking.actions' }), additionalStyle: { textAlign: 'center' } },
  ];

  const TableHeader = (
    <thead style={{ position: 'relative' }}>
      <tr>
        {fields.map(({ name, label, additionalStyle }) => {
          const isSortable = name in filters && 'sort' in filters[name] && parkings.length > 1;
          const isSortedAsc = isSortable && filters[name].sort === 'ASC';
          const isSortedDesc = isSortable && filters[name].sort === 'DESC';
          const canBeSorted = isSortedAsc || isSortedDesc;
          const toggleSort = isSortable ? () => dispatchFilters({ type: 'TOGGLE_FILTER_SORT', filter: name }) : null;

          return (
            <th
              key={name}
              onClick={toggleSort}
              style={additionalStyle}
              className={isSortable ? styles.sortable : ''}
              data-type={name}
            >
              <div className={styles.headerContent}>
                <span>{label}</span>
                {canBeSorted && (
                  <ArrowIcon
                    style={{
                      transform: isSortedAsc ? 'rotate(-180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                )}
              </div>
            </th>
          );
        })}
      </tr>
      {InitialLoadingBar}
    </thead>
  );

  return (
    <table className={styles.table}>
      {TableHeader}
      <tbody>
        {initialLoading
          ? <ParkingRow parking={{ showSkeleton: true }} />
          : parkings.map((parking) => (
            <ParkingRow key={parking.id} {...parking} />
          ))}
      </tbody>
    </table>
  );
}

export default ParkingsTable;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/ParkingsTable/ParkingsTable.jsx